import React from 'react';
import { Helmet } from 'react-helmet';
import { useLocation, Outlet } from 'react-router-dom';
import classNames from 'classnames';
import { useTranslate } from '@pegasus/translation';
import { ErrorBoundary, ErrorMessageFullScreen } from '@browsing/components';

import Footer from '@client/components/footer';
import Header from '@client/components/header';
import { isTouchScreen } from '../helpers';

const ErrorFallback = () => <ErrorMessageFullScreen path="error" withCta={false} />;

const GuestLayout: React.FC = () => {
    const location = useLocation();
    const translate = useTranslate('meta');

    const getPageClassName = () => {
        return location.pathname.split('/')[1];
    };

    return (
        <div
            id="inner-wrapper"
            className={classNames('brand-color', `${getPageClassName()}-page`, {
                'touch-device': isTouchScreen(),
                'not-touch-device': !isTouchScreen(),
            })}
        >
            <Helmet
                titleTemplate={`%s - ${translate('title')}`}
                defaultTitle={translate('title')}
                meta={[
                    {
                        name: 'description',
                        content: translate('description'),
                    },
                    {
                        name: 'keywords',
                        content: translate('keywords'),
                    },
                ]}
            />
            <Header isGuest />
            <ErrorBoundary fallbackUI={ErrorFallback} componentName="GuestLayout">
                <Outlet />
            </ErrorBoundary>
            <Footer />
        </div>
    );
};

export default GuestLayout;
